import moment from "moment";
import enums from "../enums";
import baseApi from "@/api/baseApi";
import dataAnalysisApi from "@/views/data-analysis/api";
import httpService from "@/utils/services/http_service";

export default {
  // 时间格式化
  formatDate(dateVal, isTimestamp = true, formatStr = "YYYY-MM-DD HH:mm:ss") {
    if (!dateVal) {
      return "--";
    }
    if (isTimestamp) {
      dateVal *= 1000;
    }
    return new moment(dateVal).format(formatStr);
  },
  refreshStr(needWh = true) {
    let retStr = 'refreshTm=' + (new Date()).getTime()
    if (needWh) {
      retStr = '?' + retStr
    }
    return retStr
  },
  // 地区类型通过id获取名称
  parseAreaType(value) {
    let retVal = "";
    let list = enums.AreaType.forModelList;
    let filterArr = list.filter(item => item.value == value);
    if (filterArr.length) {
      retVal = filterArr[0].label;
    }
    return retVal;
  },

  // 模型针对类型id获取名称
  parseTargeType(value) {
    let retVal = "";
    let list = enums.ModelTargetType.list;
    let filterArr = list.filter(item => item.value == value);
    if (filterArr.length) {
      retVal = filterArr[0].label;
    }
    return retVal;
  },

  // 返回地区信息列表
  async getAreaList(params = {}) {
    let queryObj = Object.assign({}, { page: 1, pagesize: enums.allPageSize }, params);
    let res = await dataAnalysisApi.areaList(queryObj);
    // let retData = res.list.map(item => {
    //   return {
    //     label: item.risk_name,
    //     value: item.id
    //   }
    // })
    return res.list;
  },

  // 返回风险类型
  async getRiskTypeList(params = { page: 1, pagesize: enums.allPageSize }) {
    let res = await dataAnalysisApi.riskTypeList(params);
    // let retData = res.list.map(item => {
    //   return {
    //     label: item.risk_name,
    //     value: item.id
    //   }
    // })

    return res.list;
  },

  // 获取采集语言列表
  async getCollectLanguageList(params = {}) {
    let res = await baseApi.getCollectLanguageList(params);
    return res.list;
  },

  generateUUID() {
    function _S4() {
      return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
    }
    function _guid() {
      return (
        _S4() +
        _S4() +
        "-" +
        _S4() +
        "-" +
        _S4() +
        "-" +
        _S4() +
        "-" +
        _S4() +
        _S4() +
        _S4()
      );
    }
    return _guid();
  },

  dateDiffStr(date1, date2) {
    let retStr = "";
    if (date1 && date2) {
      let momentObj1 = new moment(date1);
      let momentObj2 = new moment(date2);
      if (momentObj2.diff(momentObj1) <= 0) {
        return retStr;
      }

      let diffObj = momentObj2.preciseDiff(momentObj1, true);

      let diffKeys = [
        {
          key: "years",
          text: "年"
        },
        {
          key: "months",
          text: "月"
        },
        {
          key: "days",
          text: "天"
        },
        {
          key: "hours",
          text: "小时"
        },
        {
          key: "minutes",
          text: "分"
        }
      ];

      diffKeys.forEach(item => {
        if (diffObj[item.key] > 0) {
          retStr = retStr + diffObj[item.key] + item.text;
        }
      });
      console.log(retStr);
    }

    return retStr;
  },

  parseToTimestamp(date) {
    if (date && date != '--') {
      return moment(date).valueOf() / 1000;
    }
    return "";
  },

  download(url, attType) {
    httpService.download(url, {}, { mimeType: attType });
  },

  downloadImg(src) {
    var filename;

    var filetype;

    var path = src;

    if (path.indexOf("/") > 0) {
      var file = path.substring(path.lastIndexOf("/") + 1, path.length);

      var fileArr = file.toLowerCase().split(".");

      filename = fileArr[0];

      filetype = fileArr[1];
    } // var newImage = new Image(); // newImage.src = src;

    var canvas = document.createElement("canvas");

    var img = document.createElement("img");

    img.onload = function(e) {
      canvas.width = img.width;

      canvas.height = img.height;

      var context = canvas.getContext("2d");

      context.drawImage(img, 0, 0, img.width, img.height);

      canvas.getContext("2d").drawImage(img, 0, 0, img.width, img.height);

      canvas.toBlob(blob => {
        var a = document.createElement("a");

        a.href = window.URL.createObjectURL(blob);

        a.download = filename;

        a.click();
      }, `image/${filetype}`);
    };

    img.setAttribute("crossOrigin", "anonymous");

    img.src = src;
  }
};
